import React, { useEffect, useState } from "react";
import CustomTable from "../../components/customTable/CustomTable";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import { Button, Tooltip } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { formatNumber, show_proper_words } from "../../utils/constant";
import StatusChip from "../../theme/chip";
import moment from "moment";
import { _List_Transaction_For_Admin } from "../../DAL/Listing/TransactionList";
import { enqueueSnackbar } from "notistack";
import CustomCircularProgress from "../../components/CustomCircularProgress";
import CustomDrawer from "../../components/CustomDrawer";
import { Icon } from "@iconify/react/dist/iconify.js";
import FilteredChip from "../../components/FilteredChip";
import roundFilterList from "@iconify/icons-ic/round-filter-list";
import TransactionsFilter from "../Payment/TransactionsFilter";
import { Scree_Base_List } from "../../DAL/Listing/AgencyAddAcount";
import { useAdminContext } from "../../Hooks/AdminContext";

export const ClearWalletBalance = () => {
  const navigate = useNavigate();
  const { setnavbarTitle } = useAdminContext();
  const [userList, setUserList] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [totalCount, setTotalCount] = useState(0);
  const [pageCount, setPageCount] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [loading, setLoading] = useState(true);
  const [selectUsersList, setSelectUsersList] = useState([]);
  const [filterDrawerState, setFilterDrawerState] = useState(false);

  const EMPTY_FILTER = {
    user: "",
    status_value: "",
    payment_made_by: "",
  };

  const [filterData, setFilterData] = useState(EMPTY_FILTER);
  const [filterStateUpdated, setFilterStateUpdated] = useState(EMPTY_FILTER);

  // Handles the deletion of a chip by resetting account type and status value,
  // updating the request list with the modified data, and saving the filter data to localStorage.
  const HandleDeleteChip = (data) => {
    if (!data.account_type) {
      data.account_type = "";
    }
    if (!data.status_value) {
      data.status_value = "";
    }
    setPage(0);
    getRequestList(0, rowsPerPage, data);
    setFilterData(data);
    localStorage.setItem("clear_wallet_transaction_page", JSON.stringify(data));
  };

  // Handles the search functionality by resetting the page and total pages,
  // saving the current filter data to localStorage, fetching the request list,
  // and closing the filter drawer.
  const searchFunction = () => {
    setPage(0);
    setTotalPages(1);
    localStorage.setItem(
      "clear_wallet_transaction_page",
      JSON.stringify(filterData)
    );
    getRequestList(0, rowsPerPage, filterData);
    handleCloseFilterDrawer();
  };

  // Opens the filter drawer by setting the filterDrawerState to true
  const handleOpenFilterDrawer = () => {
    setFilterDrawerState(true);
  };

  // Closes the filter drawer by setting the filterDrawerState to false
  const handleCloseFilterDrawer = () => {
    setFilterDrawerState(false);
  };

  // Updates the filterData state with the new value for a specific field (name)
  const handleChangeOthers = (name, value) => {
    setFilterData((values) => ({ ...values, [name]: value }));
  };

  // Clears the filters, resets the filter data and pagination, and fetches the initial request list
  const handleClearFilter = () => {
    localStorage.removeItem("clear_wallet_transaction_page");
    setFilterData(EMPTY_FILTER);
    setPage(0);
    setPageCount(1);
    getRequestList(0, rowsPerPage, EMPTY_FILTER);
    handleCloseFilterDrawer();
  };

  // Handles page changes, updates the current page and adjusts the page count accordingly
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    if (newPage <= 0) {
      setPageCount(1);
    } else {
      setPageCount(newPage + 1);
    }
  };

  // Handles changes in the number of rows per page, resets to page 0
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // Handles changes in page number for pagination
  const handleChangePages = (event, newPage) => {
    if (newPage <= 0) {
      setPage(0);
      setPageCount(1);
    } else {
      setPage(newPage - 1);
      setPageCount(newPage);
    }
  };

  // Fetches the list of wallet transactions based on filters and pagination
  const getRequestList = async (page, rowsPerPage, filterData) => {
    const PostData = { ...filterData };

    const formData = {
      type: "clear_wallet",
      user_id: PostData?.user?.id || "",
      status: PostData?.status_value || "",
      payment_method: PostData?.payment_made_by || "",
    };

    setLoading(true);
    const res = await _List_Transaction_For_Admin(formData, page, rowsPerPage);
    if (res.code === 200) {
      let chipData = { ...filterData };
      if (chipData?.user?.id) {
        chipData.user = {
          chip_label: chipData?.user?.name,
          chip_value: chipData?.user?.id,
        };
      }
      if (chipData.payment_made_by) {
        chipData.payment_made_by = show_proper_words(chipData.payment_made_by);
      }
      if (chipData.status_value) {
        chipData.status_value =
          chipData.status_value === "succeeded"
            ? "Approved"
            : chipData.status_value === "failed"
            ? "Rejected"
            : chipData.status_value === "requires_action"
            ? "Needs Changes"
            : "Pending";
      }
      setFilterStateUpdated(chipData);
      setUserList(res?.transaction);
      setTotalPages(res?.total_pages);
      setTotalCount(res?.total_count);
      setLoading(false);
    } else {
      enqueueSnackbar(res?.message, { variant: "error" });
      setLoading(false);
    }
  };

  // Defines the table columns for displaying wallet transaction data
  const User_Table_Head = [
    {
      id: "action",
      label: "Action",
      renderData: (row) => (
        <>
          <Tooltip title="View Detail" placement="top">
            <RemoveRedEyeIcon
              onClick={() => {
                navigate(`/clear-wallet-balance/details/${row._id}`);
              }}
              style={{ fill: "#fff", marginRight: "10px", cursor: "pointer" }}
            />
          </Tooltip>
        </>
      ),
    },
    {
      id: "number",
      label: "#",
      type: "number",
    },
    {
      id: "user",
      label: "User",
      renderData: (row) => (
        <span
          className="pointer"
          onClick={() => navigate(`/clear-wallet-balance/details/${row._id}`)}
        >
          {row.user_info.first_name + " " + row.user_info.last_name || "_ _"}
          <div className="text-muted small">{row.user_info.email || "_ _"}</div>
        </span>
      ),
    },
    // {
    //   id: "name",
    //   label: "Request Title",
    // },
    {
      id: "deposit_method",
      label: "Deposit Method",
      renderData: (row) => (
        <div>
          {row.deposit_method === "domestic_wire"
            ? "Domestic Wire Transfer"
            : row.deposit_method === "international_wire"
            ? "International Wire Transfer"
            : row.deposit_method === "credit_card"
            ? "CC/Bank transfer"
            : show_proper_words(row.deposit_method) || "_ _"}
        </div>
      ),
    },
    {
      id: "Request Amount",
      label: "Request Amount",
      renderData: (row) => (
        <div>
          {row?.total_amount > 0
            ? "$" + formatNumber(row?.total_amount)
            : "_" || 0}
        </div>
      ),
    },
    {
      id: "payment_method",
      label: "Ads Spend Fee",
      renderData: (row) => (
        <div>
          {row?.processed_fee > 0
            ? "$" + formatNumber(row?.processed_fee)
            : "_" || 0}
        </div>
      ),
    },
    {
      id: "Request Amount",
      label: "Amount Sent",
      renderData: (row) => (
        <div>
          {row?.amount > 0 ? "$" + formatNumber(row?.amount) : "_" || 0}
        </div>
      ),
    },
    {
      id: "transaction_date",
      label: "Transaction Date",
      renderData: (row) => (
        <div>{moment(row.date_time).format("DD MMM YY hh:mm A") || "_ _"}</div>
      ),
    },
    {
      id: "status",
      label: "Status",
      renderData: (row) => (
        <StatusChip
          status={
            row.status === "succeeded"
              ? "Approved"
              : row.status === "failed"
              ? "Rejected"
              : row.status === "requires_action"
              ? "Needs Changes"
              : "Pending"
          }
          type="activeInactive"
        />
      ),
    },
  ];

  // Handles the fetching of user details based on the search value
  const handleGetDetailUser = async (value) => {
    const FormData = {
      type: "customer",
      search: value,
    };
    const response = await Scree_Base_List(FormData);
    if (response.code === 200) {
      const FormatData = response?.list?.map((value) => {
        return {
          id: value.user_id,
          name: show_proper_words(value.first_name + " " + value.last_name),
          email: value.email,
        };
      });
      setSelectUsersList(FormatData);
    }
  };

  useEffect(() => {
    setnavbarTitle("Clear Wallet Balance");
    handleGetDetailUser();
  }, []);

  useEffect(() => {
    const filter = JSON.parse(
      localStorage.getItem("clear_wallet_transaction_page")
    );
    if (filter) {
      setFilterData(filter);
      getRequestList(0, rowsPerPage, filter);
    } else {
      getRequestList(page, rowsPerPage, filterData);
    }
  }, [rowsPerPage, page]);

  if (loading) {
    return <CustomCircularProgress />;
  }

  return (
    <div className="mt-4">
      <div className="row mb-3">
        <div className="col-12 col-md-10">
          <FilteredChip
            data={filterStateUpdated}
            tempState={filterData}
            EMPTY_FILTER={EMPTY_FILTER}
            onDeleteChip={HandleDeleteChip}
            onClear={handleClearFilter}
          />
        </div>
        <div className="col-12 col-md-2 text-end">
          <Button variant="contained" onClick={handleOpenFilterDrawer}>
            Filters &nbsp;&nbsp; <Icon icon={roundFilterList} />
          </Button>
        </div>
      </div>
      <CustomTable
        data={userList}
        TABLE_HEAD={User_Table_Head}
        MENU_OPTIONS={[]}
        custom_pagination={{
          total_count: totalCount,
          rows_per_page: rowsPerPage,
          page: page,
          handleChangePage: handleChangePage,
          onRowsPerPageChange: handleChangeRowsPerPage,
        }}
        pageCount={pageCount}
        totalPages={totalPages}
        handleChangePages={handleChangePages}
        pagePagination={true}
        is_hide={true}
      />
      <CustomDrawer
        isOpenDrawer={filterDrawerState}
        onOpenDrawer={handleOpenFilterDrawer}
        onCloseDrawer={() => setFilterDrawerState(false)}
        pageTitle="Filters"
        componentToPassDown={
          <TransactionsFilter
            filterData={filterData}
            userList={selectUsersList}
            handleGetDetailUser={handleGetDetailUser}
            handleClearFilter={handleClearFilter}
            handleChangeOthers={handleChangeOthers}
            searchSubmitFilter={searchFunction}
            setFilterData={setFilterData}
            deposit={true}
            is_clear={false}
          />
        }
      />
    </div>
  );
};
